import { AppCard } from "../../UserDash/Components/AppCard/AppCard";
import React from "react";

const UserResults = () => {
  return <AppCard isOnlyFinished={true} />;
};
export default UserResults;
